import React, { Suspense, lazy } from 'react';
//import CurrentPage from './hooks/currentpage';
import PrivateRoute from './components/PrivateRoutes/PrivateRoutes'
import { AnalyticsProvider } from './context/AnalyticsProvider';

//import { EventEmitter } from 'events';





//import cors from 'cors';

/*import { useEffect, useState } from 'react';*/
//import Navbar from './components/Navbar';
//import Carasoule from './components/Carasoule';
//import ImageGrid from './components/ImageGrid';
//import ImageGrid from './components/editwebpagecomp/edithomep/ImageGrid';
//import Footer from './components/Footer';
import { BrowserRouter as Router, Route, Routes, Switch  } from 'react-router-dom';
import './App.css';
import Classlist from './components/adminportal/pagecomponent/adminh1/pages/classlist';
const Home = lazy(() => import('./components/pages/Home'));
const Aboutus =lazy(()=> import('./components/pages/Aboutus'));
const Adminteampage =lazy(()=> import('./components/pages/Adminteam'));
const Staffdirectorypage = lazy(() => import('./components/pages/staffdirectory'));
const Boardofdirectorspage =lazy(()=> import('./components/pages/Boardofdirectors'));
const Contactus =lazy(()=> import('./components/pages/Contactus'));
const Admissions =lazy(()=> import('./components/pages/Admissions'));
const Adminportal =lazy(() => import('./components/pages/Adminportalp'));
const Admissionsform = lazy(()=> import('./components/pages/Admissionsform'));
const Academics =lazy(()=> import('./components/pages/Academics'));
const Sports =lazy(()=> import('./components/pages/Sports'));
const PTApage =lazy(()=> import('./components/pages/PTA'));
const PTAproductpage =lazy(()=> import('./components/pages/PTAPRODUCTPAGE'));
const StudentPortal =lazy(()=> import('./components/pages/Student-Portal'));
const Gallerypage =lazy(()=> import('./components/pages/Gallery'));
const Clubspage =lazy(()=> import('./components/pages/Clubs'));
const Agriculturepage =lazy(()=> import('./components/pages/Agriculture'));
const Majoreventspage =lazy(()=> import('./components/pages/Majorevents'));
const ParentSpace =lazy(()=> import('./components/pages/Parent-Space'));
const Portals =lazy(()=> import('./components/pages/Portals'));
const Ehome = lazy(()=> import('./components/editwebpages/Ehome'));


/*import Home from './components/pages/Home';
import Aboutus from './components/pages/Aboutus';
import Adminteampage from './components/pages/Adminteam';
import Boardofdirectorspage from './components/pages/Boardofdirectors';
import Contactus from './components/pages/Contactus';
import Admissions from './components/pages/Admissions';
import Academics from './components/pages/Academics';
import Sports from './components/pages/Sports';
import PTApage from './components/pages/PTA';
import PTAproductpage from './components/pages/PTAPRODUCTPAGE';
import StudentPortal from './components/pages/Student-Portal';
import Gallerypage from './components/pages/Gallery';
import Clubspage from './components/pages/Clubs';
import Agriculturepage from './components/pages/Agriculture';
import Majoreventspage from './components/pages/Majorevents';
import ParentSpace from './components/pages/Parent-Space';
import Portals from './components/pages/Portals';

import Ehome from './components/editwebpages/Ehome';*/


//Importing pages for the students portal below here

const Phome = lazy(() => import('./components/studentportal/pages/phome')); 
const SPoutline = lazy(() => import('./components/studentportal/pages/spoutline')); 
const Pcontent = lazy(() => import('./components/studentportal/pages/pcontent')); 
const Plesson = lazy(() => import('./components/studentportal/pages/plesson')); 
const Plibrary = lazy(() => import('./components/studentportal/pages/plibrary')); 
const PExampapers = lazy(() => import('./components/studentportal/pages/pExampapers')); 
const PTestAssignment = lazy(() => import('./components/studentportal/pages/ptestassignment')); 
const PMarkedtstAssignment = lazy(() => import('./components/studentportal/pages/pmarkedtstassignment')); 
const POnlinelibrary = lazy(() => import('./components/studentportal/pages/ponlinelib')); 


/*import Phome from './components/studentportal/pages/phome';
import SPoutline from './components/studentportal/pages/spoutline';
import Pcontent from './components/studentportal/pages/pcontent';
import Plesson from './components/studentportal/pages/plesson';
import Plibrary from './components/studentportal/pages/plibrary';
import PExampapers from './components/studentportal/pages/pExampapers';
import PTestAssignment from './components/studentportal/pages/ptestassignment';
import PMarkedtstAssignment from './components/studentportal/pages/pmarkedtstassignment';
import POnlinelibrary from "./components/studentportal/pages/ponlinelib"*/


//Importing pages for the Teachers portal below here
const Addtest = lazy (() => import('./components/teacherportal/pages/Addtest')); 
const Addstart = lazy (() => import('./components/teacherportal/pages/Addstart')); 
const Editsubjects = lazy (() => import('./components/teacherportal/pages/Edsubjects')); 
const Editoutline = lazy (() => import('./components/teacherportal/pages/Edoutline')); 
const Addreportcard = lazy(() => import('./components/teacherportal/pages/Addreportcard'));
const Genreportcard = lazy(() => import('./components/teacherportal/pages/Genreportcard'));
const Leaveform = lazy(() => import('./components/teacherportal/pages/Leaveform'));
const Teachcalendarcomp = lazy(() => import('./components/teacherportal/pages/teachcalendar'));
const TeachLeaveHistorycomp = lazy(() => import('./components/teacherportal/pages/teachleavehistory'));
const Clockin = lazy (() => import ('./components/teacherportal/pages/Clockin'));
const Register = lazy(() => import('./components/teacherportal/pages/Register'));
const Groupquestion = lazy(() => import('./components/teacherportal/pages/Groupquestions'));
const Downloadregister = lazy(() => import('./components/teacherportal/pages/Downloadregister'));
const Medinfo = lazy(() => import('./components/teacherportal/pages/Medinfo'));



/*import Addtest from './components/teacherportal/pages/Addtest';
import Addstart from './components/teacherportal/pages/Addstart';
import Editsubjects from './components/teacherportal/pages/Edsubjects';
import Editoutline from './components/teacherportal/pages/Edoutline';*/


//Importing pages for the Parents portal below here
const Performancegu = lazy(() => import('./components/parentsportal/pages/perfomance')); 

/*import Performancegu from './components/parentsportal/pages/perfomance';*/

//Importing pages for the Teachers Library portal below here
const Addlibbooks = lazy(() => import('./components/libraryportal/pages/Addbooks'));
const AddOnlinelibbooks = lazy(() => import('./components/libraryportal/pages/Addonlinebooks'));
const Qrgeneratecode = lazy(() => import('./components/libraryportal/pages/Qrgenerate'));
const BooksinCirculation = lazy(() => import('./components/libraryportal/pages/Circulation'));
const Dashboardlibadim = lazy(() => import('./components/libraryportal/pages/Dashboard'));
const Circulationhistory = lazy(() => import('./components/libraryportal/pages/Circulationhistory'));
const Studentstatslib = lazy(() => import('./components/libraryportal/pages/Studentstats'));
const Studentstatuspage = lazy(() => import('./components/libraryportal/pages/Studentstatus'));
const PhyBookstatslib = lazy(() => import('./components/libraryportal/pages/Phybookstat'));
const OnlineBookstatslib = lazy(() => import('./components/libraryportal/pages/Onlinebookstats'));
const ReadingTestlib = lazy(() => import('./components/libraryportal/pages/Readingtest'));
const Readingresultslib = lazy(() => import('./components/libraryportal/pages/Readingresults'));
const Classreadingreslib = lazy(() => import('./components/libraryportal/pages/Classreadingres'));
const Addteacherlistlp = lazy(() => import('./components/libraryportal/pages/Addteacherlist'));
const Booksummarytech = lazy(() => import('./components/libraryportal/pages/Booksummary'));
const Activityanswerlp = lazy(() => import('./components/libraryportal/pages/Addactivityans'));
const Reportsinfopage = lazy(() => import('./components/libraryportal/pages/Reportinfo'));




/*
import Addlibbooks from './components/libraryportal/pages/Addbooks';
import AddOnlinelibbooks from './components/libraryportal/pages/Addonlinebooks';
import Qrgeneratecode from './components/libraryportal/pages/Qrgenerate';
import BooksinCirculation from './components/libraryportal/pages/Circulation';
import Dashboardlibadim from './components/libraryportal/pages/Dashboard';
import Circulationhistory from './components/libraryportal/pages/Circulationhistory';
import Studentstatslib from './components/libraryportal/pages/Studentstats';
import Studentstatuspage from './components/libraryportal/pages/Studentstatus';
import PhyBookstatslib from './components/libraryportal/pages/Phybookstat';
import OnlineBookstatslib from './components/libraryportal/pages/Onlinebookstats';*/


//Importing pages for the Adimin portal below here
const Addlibmember = lazy(() => import('./components/libraryportal/pages/Addmember')); 
const Adh1librarydash = lazy(() => import('./components/adminportal/pagecomponent/adminh1/pages/librarydash')); 
const Websitestats = lazy(() => import('./components/adminportal/pagecomponent/adminh1/pages/websitestats'));
const Leavedays = lazy(() => import('./components/adminportal/pagecomponent/adminh1/pages/leavedays'))
const LeaveApplications = lazy(() => import('./components/adminportal/pagecomponent/adminh1/pages/leaveapplications'))
const Employeedemog = lazy(() => import('./components/adminportal/pagecomponent/adminh1/pages/employeedemog'))
const Leavehistory = lazy(() => import('./components/adminportal/pagecomponent/adminh1/pages/leavehistory'))
const LeaveCalendar = lazy(() => import('./components/adminportal/pagecomponent/adminh1/pages/leavecalendar'))
const Schclasseslist = lazy(() => import('./components/adminportal/pagecomponent/adminh1/pages/schclasses'))
const Schteachingareaspage = lazy(() => import('./components/adminportal/pagecomponent/adminh1/pages/teachingareas'))
const Schsubjectslistpage = lazy(() => import('./components/adminportal/pagecomponent/adminh1/pages/schsubjects'))
const SchoolInvoices = lazy(() => import('./components/adminportal/pagecomponent/adminh1/pages/invoices'))
const Classlistpagen = lazy(() => import('./components/adminportal/pagecomponent/adminh1/pages/classlist'))
const ClassInvoices = lazy(() => import('./components/adminportal/pagecomponent/adminh1/pages/classinvoices'))
const Feesinvoicespayment = lazy(() => import('./components/adminportal/pagecomponent/adminh1/pages/paymentpage'))
const Mainstudentacc = lazy(() => import('./components/adminportal/pagecomponent/adminh1/pages/mainstudentacc'))
const Feestructure = lazy(() => import('./components/adminportal/pagecomponent/adminh1/pages/feestructure'))



/*
import Addlibmember from './components/libraryportal/pages/Addmember';
import Adh1librarydash from './components/adminportal/pagecomponent/adminh1/pages/librarydash';*/


//Importing pages for the Main Library portal below here Students Library Portal
const LibStudPortal = lazy(() => import("./components/pages/LibraryLoginPortal")); 
const LibStudHome = lazy(() => import('./components/studentlibraryportal/pages/libhome')); 
const OnlineLibHome = lazy(() => import('./components/studentlibraryportal/pages/onllnelibrary')); 
const OnlineLibInfor = lazy(() => import('./components/studentlibraryportal/pages/onlinebookinfo')); 
const OnlineLibdisplay = lazy(() => import('./components/studentlibraryportal/pages/onlinedisplay')); 
const OnlineCategory = lazy(() => import('./components/studentlibraryportal/pages/onlinecategory')); 
const Borrowbook = lazy(() => import('./components/studentlibraryportal/pages/borrowbook')); 
const Borrowbookinfo = lazy(() => import('./components/studentlibraryportal/pages/borrowbookinfo')); 
const PhysicalCategory = lazy(() => import('./components/studentlibraryportal/pages/physicalcategory')); 
const Booksummaryp = lazy(() => import('./components/studentlibraryportal/pages/booksummary'));
const Mysummariesp = lazy(() => import('./components/studentlibraryportal/pages/mysummaries'))
const Classactivityp = lazy(() => import('./components/studentlibraryportal/pages/classactivity'));
const Individualactivityp = lazy(() => import('./components/studentlibraryportal/pages/individualactivity'));




/*import LibStudPortal from "./components/pages/LibraryLoginPortal"
import LibStudHome from './components/studentlibraryportal/pages/libhome';
import OnlineLibHome from './components/studentlibraryportal/pages/onllnelibrary';
import OnlineLibInfor from './components/studentlibraryportal/pages/onlinebookinfo';
import OnlineLibdisplay from './components/studentlibraryportal/pages/onlinedisplay';
import OnlineCategory from './components/studentlibraryportal/pages/onlinecategory';
import Borrowbook from './components/studentlibraryportal/pages/borrowbook';
import Borrowbookinfo from './components/studentlibraryportal/pages/borrowbookinfo';
import PhysicalCategory from './components/studentlibraryportal/pages/physicalcategory';*/

//Importing pages for the Main Library portal below here PTA Portal
const Addptaproductp = lazy(() => import('./components/PTA/pages/Addptaproduct')); 
const Ordersp = lazy(() => import('./components/PTA/pages/Orders'));
const PtaPosp = lazy(() => import('./components/PTA/pages/PtaPos'));




const Culturepage = lazy(() => import('./components/pages/Culture')); 


/*import Addptaproductp from './components/PTA/pages/Addptaproduct';
import Culturepage from './components/pages/Culture';*/




//import { getPosts } from './actions/posts';
//import { getUser } from './actions/users';

/*
                <Routes>
                    <Route path='/' exact element={<Catlogue currentId={currentId} setCurrentId={setCurrentId} />} />
                </Routes>
                 <Carasoule />

                <ImageGrid />

                <GridWithText />
                 <PrivateRoute path='/addmember' exact element={<Addlibmember /> } />
*/
//const emitter = new EventEmitter(); // Create an event emitter

/*const useCurrentPage = () => {
    const [currentPage, setCurrentPage] = useState(window.location.pathname);

    const handleLocationChange = () => {
        setCurrentPage(window.location.pathname);
    };

    const handleHashChange = () => {
        setCurrentPage(window.location.pathname);
    };

    useEffect (() => {
       
        window.addEventListener("popstate", handleLocationChange);
        window.addEventListener('hashchange', handleHashChange);

        return () => {
            window.removeEventListener('popstate', handleLocationChange);
            window.removeEventListener('hashchange', handleHashChange);
        };
    }, []);

    return currentPage;
}*/





const App = () => {

    //const [currentId, setCurrentId] = useState(null);

   /* const [authenticated, setAuthenticated] = useState(false);

    const dispatch = useDispatch();
    
    useEffect(() => {
        dispatch(getPosts());
        //console.log("dispatch",dispatch)
    }, [dispatch]);*/

    /*useEffect(() => {
        dispatch(getUser());
    }, [dispatch]);*/

   

  /*useEffect(() => {
        // Check if the user is authenticated by making a request to the server
        console.log("running the authenticated")
        const fetchContents = async () => {
            axios.defaults.withCredentials = true;
            await axios.get('http://localhost:5000/requireAuth')
            .then((response) => {
                setAuthenticated(true);
                if (response.data.message === "library"){
                    setAuthenticated(true);
                    console.log("see response here",response.data.message)
                    console.log("authenticated")
                }
            })
            .catch((error) => {
                setAuthenticated(false);
                console.log(error)
                console.log(error.response.data.message);
                console.log("error")
            });
        };
        fetchContents();
    }, [authenticated, []]);


    console.log("see authenticated",authenticated)*/

  /*useEffect(() => {

    try {
        axios.defaults.withCredentials = true;

        const response = axios.get('http://localhost:5000/requireAuth');

    
        if (response.status === 200) {
        // The server has set a user cookie upon successful login
        // You can handle the user login and redirect the user as needed.
        console.log('Login successful');
        setAuthenticated(true);
        }
        <Route path='/about-us' element={(authenticated) ? <Aboutus /> : <Navigate to="/portals" state={{data: {portalname: "Library"} }} /> } />


    } catch (error) {
        console.error('Login failed:', error);
        setAuthenticated(false);
    } 
    }, []);
    
    <Route path='/addmember' exact element={(authenticated === "library") ? <Addlibmember /> : <Navigate to="/portals" state={{data: {portalname: "Library"} }} />} />
     <Routes>
                    <Route path="/addmember" element={<PrivateRoute component={<Addlibmember/>}/>} />
                </Routes>


                <Routes>
                    <Route path='/' exact element={<Home />} />
                </Routes> 

                <Route path='/addonlinebooks' exact element={<AddOnlinelibbooks />} /> 

                <Route path='*' exact element={<PrivateRoute path="/addmember" element={<Addlibmember />} role={'library'} />} />
    */
      /*        <Route path='*' exact element={
                        <>
                        <PrivateRoute path="/dashboardlibadim" element={<Dashboardlibadim />} role={['library']} />
                        <PrivateRoute path="/addmember" element={<Addlibmember />} role={['library']} />
                        <PrivateRoute path="/addonlinebooks" element={<AddOnlinelibbooks />} role={['library']}/>
                        <PrivateRoute path="/addbooks" element={<Addlibbooks />} role={['library']}/>
                        <PrivateRoute path="/circulation" element={<BooksinCirculation />} role={['library']}/> 


                        <PrivateRoute path="/libraydashadh1" element={<Adh1librarydash />} role={['adminh1']}/>
                        </>
                    }
                    />
                    */
   
    //const [currentPage, setCurrentPage] = useState(window.location.pathname);
    
    return(
        
        <>
            <Router>
                <AnalyticsProvider>

                <Suspense fallback={<div>Loading...</div>}>
                <Routes>
                    <Route path='/' exact element={<Home />} />
               
                    <Route path="/about-us" exact element={<Aboutus />} />
                
                    <Route path='/contact-us' exact element={<Contactus />} />
                
                    <Route path='/admissions' exact element={<Admissions />} />

                    <Route path='/admissionsform' exact element={<Admissionsform/>} />
                
                    <Route path='/academics' exact element={<Academics />} />

                    <Route path='/sports' exact element={<Sports />} />

                    <Route path='/pta' exact element={<PTApage />} />

                    <Route path='/gallery' exact element={<Gallerypage />} />

                    <Route path='/majorevents' exact element={<Majoreventspage />} />

                    <Route path='/clubs' exact element={<Clubspage />} />

                    <Route path='/culture' exact element={<Culturepage />} />

                    <Route path='/agriculture' exact element={<Agriculturepage />} />

                    <Route path='/adminteam' exact element={<Adminteampage />} />

                    <Route path='/staffdeirectory' exact element={<Staffdirectorypage/>} />

                    <Route path='/boardofdirectors' exact element={<Boardofdirectorspage />} />

                    <Route path='/ptaproductpage' exact element={<PTAproductpage />} />
              
                    <Route path='/studentportal' exact element={<StudentPortal />} />
                
                    <Route path='/phome' exact element={<Phome />} />
               
                    <Route path='/parents-space' exact element={<ParentSpace />} />
                
                    <Route path='/portals' exact element={<Portals /> } />
                    
                    <Route path='/adminlogin' exact element={<Adminportal /> } />
                
                    <Route path='/ehome' exact element={<Ehome />} />
               
                    <Route path='/Outline' exact element={<SPoutline />} />
                
                    <Route path='/Content' exact element={<Pcontent />} />
                
                    <Route path='/Lesson' exact element={<Plesson />} />
                
                    <Route path='/Library' exact element={<Plibrary />} />
               
                    <Route path='/Exampapers' exact element={<PExampapers />} />
                
                    <Route path='/TestAssignment' exact element={<PTestAssignment />} />
                
                    <Route path='/MarkedTestAssignment' exact element={<PMarkedtstAssignment />} />
                
                    <Route path='/addtest' exact element={<Addtest />} />
                
                    <Route path='/addstart' exact element={<Addstart />} />
                
                    <Route path='/editsubjects' exact element={<Editsubjects />} />
                
                    <Route path='/editoutline' exact element={<Editoutline />} />
                
                    <Route path='/performancegu' exact element={<Performancegu />} />
                      
                    <Route path='/qrgenerate' exact element={<Qrgeneratecode />} /> 

                

                    <Route path='/dashboardlibadim' exact element={<PrivateRoute  element={<Dashboardlibadim />} role={['library']} />}/>
                    <Route path='/addmember' exact element={<PrivateRoute element={<Addlibmember />} role={['library']} />}/>
                    <Route path='/addonlinebooks' exact element={ <PrivateRoute element={<AddOnlinelibbooks />} role={['library']}/>}/>
                    <Route path='/addbooks' exact element={<PrivateRoute element={<Addlibbooks />} role={['library']}/>}/>
                    <Route path='/circulation' exact element={<PrivateRoute element={<BooksinCirculation />} role={['library']}/> }/>
                    <Route path='/readingtest' exact element={<PrivateRoute element={<ReadingTestlib />} role={['library']}/> }/>
                    <Route path='/readingresults' exact element={<PrivateRoute element={<Readingresultslib />} role={['library']}/> }/>
                    <Route path='/classreadingresults' exact element={<PrivateRoute element={<Classreadingreslib />} role={['library','adminh1']}/> }/>
                    <Route path='/addteacherlist' exact element={<PrivateRoute element={<Addteacherlistlp />} role={['library']}/> }/>
                    <Route path='/evaluatesummary' exact element={<PrivateRoute element={<Booksummarytech />} role={['library']}/> }/>
                    <Route path='/activityanswer' exact element={<PrivateRoute element={<Activityanswerlp />} role={['library']}/> }/>
                    <Route path='/reportsubjectslist' exact element={<PrivateRoute element={<Reportsinfopage />} role={['library']}/> }/>


                    <Route path='/libraydashadh1' exact element={<PrivateRoute element={<Adh1librarydash />} role={['adminh1']}/>}/>
                    <Route path='/websitestats' exact element={<PrivateRoute element={<Websitestats />} role={['adminh1']}/>}/>
                    <Route path='/leavedays' exact element={<PrivateRoute element={<Leavedays />} role={['adminh1']}/>}/>
                    <Route path='/leaveapplications' exact element={<PrivateRoute element={<LeaveApplications />} role={['adminh1']}/>}/> 
                    <Route path='/employeedemographics' exact element={<PrivateRoute element={<Employeedemog />} role={['adminh1']}/>}/>
                    <Route path='/leavehistory' exact element={<PrivateRoute element={<Leavehistory />} role={['adminh1']}/>}/> 
                    <Route path='/leavecalendar' exact element={<PrivateRoute element={<LeaveCalendar />} role={['adminh1']}/>}/> 
                    <Route path='/classeslist' exact element={<PrivateRoute element={<Schclasseslist />} role={['adminh1']}/>}/> 
                    <Route path='/teachingareas' exact element={<PrivateRoute element={<Schteachingareaspage />} role={['adminh1']}/>}/> 
                    <Route path='/subjectlist' exact element={<PrivateRoute element={<Schsubjectslistpage />} role={['adminh1']}/>}/> 
                    <Route path='/invoices' exact element={<PrivateRoute element={<SchoolInvoices />} role={['adminh1']}/>}/>
                    <Route path='/classlist' exact element={<PrivateRoute element={<Classlistpagen />} role={['adminh1']}/>}/>
                    <Route path='/classinvoices' exact element={<PrivateRoute element={<ClassInvoices />} role={['adminh1']}/>}/>
                    <Route path='/feespayment' exact element={<PrivateRoute element={<Feesinvoicespayment />} role={['adminh1']}/>}/>
                    <Route path='/accounts' exact element={<PrivateRoute element={<Mainstudentacc />} role={['adminh1']}/>}/>
                    <Route path='/feestructure' exact element={<PrivateRoute element={<Feestructure />} role={['adminh1']}/>}/>

                    
                    
                    
                

                    


                    <Route path='/onlinelibrary' exact element={<POnlinelibrary />} />

                    <Route path='/studentlibrarylogin' exact element={<LibStudPortal />} />

                    <Route path='/libraryhome' exact element={<PrivateRoute element={<LibStudHome />} role={['library','adminh1','student']}/>} /> 

                    <Route path='/onlinelibcat' exact element={<PrivateRoute element={<OnlineLibHome />} role={['library','adminh1','student']}/>} /> 

                    <Route path='/onlinelibinfo' exact element={<PrivateRoute element={<OnlineLibInfor />} role={['library','adminh1','student']}/>} />

                    <Route path='/onlinedisplay' exact element={<PrivateRoute element={<OnlineLibdisplay />} role={['library','adminh1','student']}/>} />

                    <Route path='/onlinecategory' exact element={<PrivateRoute element={<OnlineCategory />} role={['library','adminh1','student']}/>} /> 

                    <Route path='/borrowbook' exact element={<PrivateRoute element={<Borrowbook />} role={['library','adminh1','student']}/>} /> 

                    <Route path='/borrowbookinfo' exact element={<PrivateRoute element={<Borrowbookinfo />} role={['library','adminh1','student']}/>} /> 

                    <Route path='/phycategory' exact element={<PrivateRoute element={<PhysicalCategory />} role={['library','adminh1','student']}/>} />
                    
                    <Route path='/booksummary' exact element={<PrivateRoute element={<Booksummaryp />} role={['library','adminh1','student']}/>} />
                    
                    <Route path='/mysummaries' exact element={<PrivateRoute element={<Mysummariesp />} role={['library','adminh1','student']}/>} />
                    
                    <Route path='/classactivities' exact element={<PrivateRoute element={<Classactivityp />} role={['library','adminh1','student']}/>} />
                    
                    <Route path='/individualactivities' exact element={<PrivateRoute element={<Individualactivityp />} role={['library','adminh1','student']}/>} />


                    

                    <Route path='/onlinebookstats' exact element={<PrivateRoute element={<OnlineBookstatslib />} role={['library','adminh1']}/>}/>

                    <Route path='/phybookstats' exact element={<PrivateRoute element={<PhyBookstatslib />} role={['library','adminh1']}/>}/> 

                    <Route path='/studentsstatslib' exact element={<PrivateRoute element={<Studentstatslib />} role={['library','adminh1']}/>}/>   

                    <Route path='/studentsstatus' exact element={<PrivateRoute element={<Studentstatuspage />} role={['library','adminh1']}/>}/>   

                    <Route path='/circulationhistory' exact element={<PrivateRoute element={<Circulationhistory />} role={['library','adminh1']}/>}/>   

                    <Route path='/addptaproduct' exact element={<PrivateRoute element={<Addptaproductp />} role={['pta']}/>}/>  
                    <Route path='/orders' exact element={<PrivateRoute element={<Ordersp />} role={['pta']}/>}/>
                    <Route path='/ptapos' exact element={<PrivateRoute element={<PtaPosp />} role={['pta']}/>}/> 

                    <Route path='/addreportcard' exact element={<PrivateRoute element={<Addreportcard />} role={['library', 'staff', 'admin']}/>}/>
                    <Route path='/generatereportcard' exact element={<PrivateRoute element={<Genreportcard />} role={['library', 'staff', 'admin']}/>}/>
                    <Route path='/leaveform' exact element={<PrivateRoute element={<Leaveform />} role={['library', 'staff', 'admin']}/>}/>
                    <Route path='/teachercalendar' exact element={<PrivateRoute element={<Teachcalendarcomp />} role={['library', 'staff', 'admin']}/>}/>
                    <Route path='/teacherleavehistory' exact element={<PrivateRoute element={<TeachLeaveHistorycomp  />} role={['library', 'staff', 'admin']}/>}/>  
                    <Route path='/clockin' exact element={<PrivateRoute element={<Clockin  />} role={['library', 'staff', 'admin']}/>}/> 
                    <Route path='/register' exact element={<PrivateRoute element={<Register  />} role={['library', 'staff', 'adminh1']}/>}/> 
                    <Route path='/groupquestion' exact element={<PrivateRoute element={<Groupquestion  />} role={['library', 'staff', 'adminh1']}/>}/> 
                    <Route path='/downloadregister' exact element={<PrivateRoute element={<Downloadregister />} role={['library', 'staff', 'adminh1']}/>}/> 
                    <Route path='/medinfo' exact element={<PrivateRoute element={<Medinfo />} role={['library', 'staff', 'adminh1']}/>}/>
   
                </Routes>
                </Suspense>

                </AnalyticsProvider>

                



                

                

                 
            </Router>
            
            
        </>
        
    );
}

export default App;